export class TrackUserIpRequestModel {
  ipAddress: string;
  latitude: number;
  longitude: number;
  zipCode: string;
  city: string;
  autonomousSystemNumber: string;
}
